import {
    EDIT_UPDATE_SUCCESS,
    LOGIN_USER_SUCCESS,
    USER_POINTS_UPDATE_SUCCESS,
    USER_UPDATE_SUCCESS,

    USER_GET_AVATAR,
    USER_GET_AVATAR_SUCCESS,
    USER_GET_AVATAR_FAILED,

    LOGOUT_USER
} from '../actions/types'

const INITIAL_STATE = {
    userId: '',
    userName: '',
    nickname: '',
    points: 0,

    group: '',
    groupId: '',

    avatarColor: null,
    userAvatar: null,
    fetchingAvatar: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case LOGOUT_USER:
            return INITIAL_STATE;

        case LOGIN_USER_SUCCESS:
            return {
                userId: action.payload.userId,
                userName: action.payload.personalData.userName,
                nickname: action.payload.personalData.userNickname,
                avatarColor: action.payload.personalData.userAvatarColor,
                points: action.payload.personalData.points,
                group: action.payload.personalData.group,
                groupId: action.payload.personalData.groupId,
            };

        case USER_POINTS_UPDATE_SUCCESS:
            return {
                ...state,
                points: action.payload
            };

        case EDIT_UPDATE_SUCCESS:
            return {
                ...state,
                userName: action.payload.userName,
                nickname: action.payload.userNickname,
            };

        case USER_UPDATE_SUCCESS:
            return {
                ...state,
                userId: action.payload.userId,
                userName: action.payload.userName,
                nickname: action.payload.userNickname,
                avatarColor: action.payload.avatarColor,
                points: action.payload.points,
                userAvatar: action.payload.userAvatar
            };

        case USER_GET_AVATAR:
                return {
                    ...state,
                    fetchingAvatar: true
                };

        case USER_GET_AVATAR_FAILED:
            return {
                ...state,
                fetchingAvatar: false,
            };

        case USER_GET_AVATAR_SUCCESS:
            return {
                ...state,
                fetchingAvatar: true,
                userAvatar: action.payload.data
            };

        default: return state;
    }
}
